"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transition = transition;
exports.default = exports.defaultProps = void 0;
var defaultProps = {
  '$enable-transitions': true
};
/**
 * @public
 * @description Enables transition if enableTransitions is true.
 * @param {boolean} enableTransitions
 * @param {array} args
 * @returns {string}
 */
// eslint-disable-next-line consistent-return

exports.defaultProps = defaultProps;

function transition() {
  var enableTransitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$enable-transitions'];

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (enableTransitions && args.length) {
    return "\n      transition: ".concat(args.join(' '), ";\n    ");
  }

  return '';
}

var _default = {
  transition: transition
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bootstrap-styled/css-mixins/lib/transition.js
// module id = 141
// module chunks = 0